import request from '@/config'
import { userBaseDto, userSearchDto, userDeletDto } from './module'

enum Apis {
    List = `/api/users/getuserpage`,        // 列表
    Detail = `/api/users/getuserinfo`,      // 明细
    Create = `/api/users/insertuser`,       // 新增
    Editor = `/api/users/updateuser`,       // 修改
    Delete = `/api/users/deleteuser`,       // 删除
    ErpAsync = `/api/users/erpuser`,        // 同步ERP数据
    ErpUserInfo = `api/users/erpuserinforeg`,  // 获取ERP用户信息（注册查询用）
}

export const ErpUserAsyncApi = (asyancData: any): Promise<IResponse> => {
    return request.post({ url: Apis.ErpAsync, data: asyancData })
}

export const GetuserListApi = (search: userSearchDto): Promise<IResponse> => {
    return request.post({ url: Apis.List, data: search })
}

export const GetuserInfoApi = (rowId: string): Promise<IResponse> => {
    return request.post({ url: Apis.Detail, data: { id: rowId } })
}

export const CreateuserApi = (input: userBaseDto): Promise<IResponse> => {
    return request.post({ url: Apis.Create, data: input })
}

export const EditoruserApi = (input: userBaseDto): Promise<IResponse> => {
    return request.post({ url: Apis.Editor, data: input })
}

export const DeleteuserApi = (input: userDeletDto): Promise<IResponse> => {
    return request.post({ url: Apis.Editor, data: input })
}

export const GetErpUserInfoApi = (asyancData: any): Promise<IResponse> => {
    return request.post({ url: Apis.ErpUserInfo, data: asyancData })
}